<template>
<div>
    <div class='init_text' v-if='openHint'>正在进入系统...</div>
    <iframe ref="monitor" :src="url+'/#/'+routeUrl+'?token='+token+'&openType=login'+'&username='+username" frameborder="0"></iframe>
</div>
</template>

<script>

    import config from "../config.js"

    export default {
        data() {
            return {
                openHint: true,
            }
        },
        computed: {
            url() {
                let http_url = config.url;
                if(process.env.NODE_ENV === "development") http_url = config.dev_url
                return http_url
            },
            token() {
                return localStorage.getItem('token')
            },
            username() {
                return localStorage.getItem('username')
            },
            routeUrl() {
                let r_url = localStorage.getItem('route');
                if(!r_url) r_url = "defaultPage";
                return r_url
            }
        },
        mounted() {
            if(!this.token) this.$router.replace('/');
            let self = this;
            // 接收退出登录的信息
            window.addEventListener('message',function(e){
                    console.log('接收的消息',e.data);
                    if(e.data.msg == "out") {
                        let token = localStorage.getItem('token');
                        localStorage.clear();
                        self.$router.replace('/')
                        if(token) {
                            self.$message({
                                message: '已退出登录',
                                type: 'success'
                            });
                        }
                    }
                    if(e.data.msg == "openSuccess") {
                        self.openHint = false;
                    }
                    if(e.data.msg.type) {
                        if(e.data.msg.type == "route") {
                            localStorage.setItem('route',e.data.msg.name)
                        }
                    }
            });
        },
    }
</script>

<style lang="scss" scoped>
.init_text {
  text-align: center;
  margin-top: 100px;
  color: #999;
}
iframe {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    background: #fff;
}
</style>


// WEBPACK FOOTER //
// src/pages/home/index.vue